module.exports = __webpack_public_path__ + "img/mobileresidentBanner.5dc86252.png";